module.exports = __webpack_public_path__ + "media/images/emoticons/zero-d15a637b28a3b27716d4c1bbb47e3f7d.gif";